<template>
  <div>
    <v-container v-if="isPermissionCanView" fluid>
      <v-row class="mb-1">
        <v-col cols="auto">
          <div class="text-h5 mt-1">นำออกข้อมูลพนักงาน</div>
        </v-col>
      </v-row>

      <CustomCardFormViewModern
        title="ตัวกรองข้อมูล"
        :isShowTitle="true"
        :isTitleHighlight="true"
        :setPaddingToCardText="true"
      >
        <!-- ประเภทข้อมูล -->
        <v-row no-gutters class="px-9 pt-5 pb-2">
          <v-col cols="12">
            <InputView title="ประเภทข้อมูล" :isRequired="true">
              <v-radio-group
                v-model="dataType"
                row
                hide-details
                class="mt-1"
                @change="onDataTypeChange"
              >
                <v-radio label="ข้อมูลพนักงาน" value="profile"></v-radio>
                <v-radio label="การลา" value="timeoff"></v-radio>
                <v-radio label="ใบงาน/การจ่ายเงิน" value="payment"></v-radio>
                <v-radio label="ประวัติรถประจำตัว" value="vehicleHistory"></v-radio>
              </v-radio-group>
            </InputView>
          </v-col>
        </v-row>

        <v-divider class="mx-6"></v-divider>

        <!-- Filters: ข้อมูลพนักงาน -->
        <template v-if="dataType === 'profile'">
          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" md="4" class="px-3">
              <InputView title="สถานะพนักงาน">
                <v-select
                  v-model="profileFilter.empStatus"
                  :items="empStatusList"
                  item-text="label"
                  item-value="key"
                  placeholder="เลือกสถานะ"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
            <v-col cols="12" md="4" class="px-3">
              <InputView title="ตำแหน่ง">
                <v-select
                  v-model="profileFilter.position"
                  :items="positionList"
                  item-text="label"
                  item-value="key"
                  placeholder="เลือกตำแหน่ง"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
            <v-col cols="12" md="4" class="px-3">
              <InputView title="บริษัท">
                <v-autocomplete
                  v-model="profileFilter.company"
                  :items="companyUserList"
                  placeholder="เลือกบริษัท"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
          </v-row>
          <v-row no-gutters class="px-6 pb-4">
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันเริ่มงานเริ่มต้น">
                <v-menu
                  v-model="profileFilter.joinStartDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="profileFilter.joinStartDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="profileFilter.joinStartDate"
                    @input="profileFilter.joinStartDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันเริ่มงานสิ้นสุด">
                <v-menu
                  v-model="profileFilter.joinEndDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="profileFilter.joinEndDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="profileFilter.joinEndDate"
                    @input="profileFilter.joinEndDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
          </v-row>
        </template>

        <!-- Filters: การลา -->
        <template v-if="dataType === 'timeoff'">
          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันที่เริ่มต้น" :isRequired="true">
                <v-menu
                  v-model="timeoffFilter.startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="timeoffFilter.startDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="timeoffFilter.startDate"
                    @input="timeoffFilter.startDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันที่สิ้นสุด" :isRequired="true">
                <v-menu
                  v-model="timeoffFilter.endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="timeoffFilter.endDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="timeoffFilter.endDate"
                    @input="timeoffFilter.endDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="ประเภทการลา">
                <v-select
                  v-model="timeoffFilter.timeoffType"
                  :items="timeoffTypeList"
                  placeholder="เลือกประเภท"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="สถานะ">
                <v-select
                  v-model="timeoffFilter.status"
                  :items="timeoffStatusList"
                  item-text="label"
                  item-value="key"
                  placeholder="เลือกสถานะ"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
          </v-row>
          <v-row no-gutters class="px-6 pb-4">
            <v-col cols="12" md="4" class="px-3">
              <InputView title="พนักงาน">
                <v-autocomplete
                  v-model="timeoffFilter.userId"
                  :items="driverList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกพนักงาน"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
            <v-col cols="12" md="2" class="px-3">
              <InputView title="ปี">
                <v-select
                  v-model="timeoffFilter.year"
                  :items="yearList"
                  placeholder="เลือกปี"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
          </v-row>
        </template>

        <!-- Filters: ใบงาน/การจ่ายเงิน -->
        <template v-if="dataType === 'payment'">
          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันที่เริ่มต้น" :isRequired="true">
                <v-menu
                  v-model="paymentFilter.startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="paymentFilter.startDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paymentFilter.startDate"
                    @input="paymentFilter.startDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="วันที่สิ้นสุด" :isRequired="true">
                <v-menu
                  v-model="paymentFilter.endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="paymentFilter.endDate"
                      placeholder="เลือกวันที่"
                      class="app-custom-input custom-placeholer-color"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paymentFilter.endDate"
                    @input="paymentFilter.endDateMenu = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="พนักงาน">
                <v-autocomplete
                  v-model="paymentFilter.driverId"
                  :items="driverList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกพนักงาน"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
            <v-col cols="12" md="3" class="px-3">
              <InputView title="สัญญา">
                <v-autocomplete
                  v-model="paymentFilter.contractId"
                  :items="contractList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกสัญญา"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
          </v-row>
        </template>

        <!-- Filters: ประวัติรถประจำตัว -->
        <template v-if="dataType === 'vehicleHistory'">
          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" md="4" class="px-3">
              <InputView title="พนักงาน">
                <v-autocomplete
                  v-model="vhFilter.driverId"
                  :items="driverList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกพนักงาน"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
          </v-row>
        </template>

        <div class="px-9 pb-3">
          <span class="red--text text-app-small"
            >* ถ้าว่างไว้หมายถึงเงื่อนไขทั้งหมด</span
          >
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="px-9 py-4" align="center">
          <v-col cols="auto" v-if="dataType === 'profile'">
            <InputView title="รูปแบบการนำออก" :isRequired="true">
              <v-radio-group
                v-model="profileFilter.exportType"
                row
                hide-details
                class="mt-1"
              >
                <v-radio label="แบบย่อ (HR)" value="short"></v-radio>
                <v-radio label="แบบเต็ม" value="full"></v-radio>
              </v-radio-group>
            </InputView>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" :class="dataType === 'profile' ? 'pt-7' : ''">
            <PrimaryButton
              icon="mdi-download"
              :loading="exportLoading"
              @on-click="exportCSV"
            >
              นำออก CSV
            </PrimaryButton>
          </v-col>
        </v-row>
      </CustomCardFormViewModern>
    </v-container>
    <AppPageNotFound :show="isPermissionCanView" />

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AppPageNotFound from "@/components/AppPageNotFound.vue";
import CustomCardFormViewModern from "@/components/CustomCardFormViewModern.vue";
import InputView from "@/components/InputView.vue";
import PrimaryButton from "@/components/PrimaryButton.vue";
import {
  getExportEmpStatuses,
  getExportPositions,
  getExportDrivers,
  getExportContracts,
  getExportUser,
  getExportUserTimeoff,
  getExportUserPayment,
  getExportUserVehicleHistory,
} from "@/services/api/export_data";
import moment from "moment";

export default {
  name: "ExportUserView",
  components: {
    AppPageNotFound,
    CustomCardFormViewModern,
    InputView,
    PrimaryButton,
  },
  data() {
    const currentYear = moment().format("YYYY");
    const years = [];
    for (let y = parseInt(currentYear); y >= 2023; y--) {
      years.push(String(y));
    }

    return {
      isPermissionCanView: false,
      exportLoading: false,
      dataType: "profile",
      //
      empStatusList: [],
      positionList: [],
      driverList: [],
      contractList: [],
      companyUserList: [],
      yearList: years,
      timeoffTypeList: ["ลาป่วย", "ลากิจ"],
      timeoffStatusList: [
        { key: "NEW", label: "รอดำเนินการ" },
        { key: "APPROVED", label: "อนุมัติ" },
      ],
      //
      profileFilter: {
        empStatus: "ACTIVE",
        position: null,
        company: null,
        joinStartDate: null,
        joinEndDate: null,
        joinStartDateMenu: false,
        joinEndDateMenu: false,
        exportType: "short",
      },
      timeoffFilter: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        startDateMenu: false,
        endDateMenu: false,
        userId: null,
        timeoffType: null,
        status: null,
        year: currentYear,
      },
      paymentFilter: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        startDateMenu: false,
        endDateMenu: false,
        driverId: null,
        contractId: null,
      },
      vhFilter: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        startDateMenu: false,
        endDateMenu: false,
        driverId: null,
      },
      //
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  mounted() {
    this.checkUserPermissions();
    if (this.isPermissionCanView) {
      this.loadFilterOptions();
    }
  },
  methods: {
    checkUserPermissions() {
      if (this.$store.getters.userInfo !== null) {
        let permissions = this.$store.getters.userInfo.permissions;
        if (
          permissions &&
          (permissions.includes("ADMIN_ALL") ||
            permissions.includes("EXPORT_DATA_VIEW"))
        ) {
          this.isPermissionCanView = true;
        }
      }
    },

    async loadFilterOptions() {
      const [empStatuses, positions, drivers, contracts] = await Promise.all([
        getExportEmpStatuses(this.$store),
        getExportPositions(this.$store),
        getExportDrivers(this.$store),
        getExportContracts(this.$store),
      ]);

      if (empStatuses.code === 200 && empStatuses.data) {
        this.empStatusList = empStatuses.data;
      }
      if (positions.code === 200 && positions.data) {
        this.positionList = positions.data;
      }
      if (drivers.code === 200 && drivers.data) {
        this.driverList = drivers.data;
      }
      if (contracts.code === 200 && contracts.data) {
        this.contractList = contracts.data.map((c) => ({
          ...c,
          displayLabel: `${c.contractNumber} : ${c.title}`,
        }));
      }
    },

    onDataTypeChange() {
      // reset on change
    },

    async exportCSV() {
      this.exportLoading = true;
      try {
        let resp;
        let filename;

        switch (this.dataType) {
          case "profile":
            resp = await getExportUser(this.$store, {
              empStatus: this.profileFilter.empStatus,
              position: this.profileFilter.position,
              joinStartDate: this.profileFilter.joinStartDate,
              joinEndDate: this.profileFilter.joinEndDate,
              exportType: this.profileFilter.exportType,
            });
            filename = `ข้อมูลพนักงาน_${moment().format("YYYY-MM-DD")}`;
            break;

          case "timeoff":
            resp = await getExportUserTimeoff(this.$store, {
              startDate: this.timeoffFilter.startDate,
              endDate: this.timeoffFilter.endDate,
              userId: this.timeoffFilter.userId,
              timeoffType: this.timeoffFilter.timeoffType,
              status: this.timeoffFilter.status,
              year: this.timeoffFilter.year,
            });
            filename = `การลา_${this.timeoffFilter.startDate || "ทั้งหมด"}_${this.timeoffFilter.endDate || "ทั้งหมด"}`;
            break;

          case "payment":
            resp = await getExportUserPayment(this.$store, {
              startDate: this.paymentFilter.startDate,
              endDate: this.paymentFilter.endDate,
              driverId: this.paymentFilter.driverId,
              contractId: this.paymentFilter.contractId,
            });
            filename = `ใบงานการจ่ายเงิน_${this.paymentFilter.startDate || "ทั้งหมด"}_${this.paymentFilter.endDate || "ทั้งหมด"}`;
            break;

          case "vehicleHistory":
            resp = await getExportUserVehicleHistory(this.$store, {
              driverId: this.vhFilter.driverId,
            });
            filename = `ประวัติรถประจำตัว_${moment().format("YYYY-MM-DD")}`;
            break;
        }

        if (resp && resp.code === 200 && resp.data) {
          const records = resp.data.records;
          if (records.length === 0) {
            this.showSnackbar("ไม่มีข้อมูลสำหรับนำออก", "warning");
            this.exportLoading = false;
            return;
          }

          const headers = Object.keys(records[0]);
          const csvRows = [headers.join(",")];
          for (const row of records) {
            const values = headers.map((h) => {
              let val = row[h];
              if (val === null || val === undefined) return "";
              val = String(val).replace(/"/g, '""');
              return `"${val}"`;
            });
            csvRows.push(values.join(","));
          }
          const csvContent = csvRows.join("\n");
          const blob = new Blob(["\uFEFF" + csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${filename}.csv`;
          a.click();
          URL.revokeObjectURL(url);
          this.showSnackbar(
            `นำออกสำเร็จ ${records.length} รายการ`,
            "success"
          );
        }
      } catch (err) {
        this.showSnackbar("ไม่สามารถนำออกข้อมูลได้", "error");
      }
      this.exportLoading = false;
    },

    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>
